import { useCallback, useState } from 'react';
/**
 * Отслеживает, что элемент был проскроллен
 * @returns Объект с состоянием скролла и колбэком для обработки события скролла
 * @example
 * ```tsx
 * const ScrollableComponent = () => {
 *   const { isScrolling, onScroll } = useIsScrolling();
 *
 *   return (
 *     <div>
 *       <div
 *         onScroll={onScroll}
 *         style={{
 *           height: '200px',
 *           overflowY: 'auto',
 *           border: '1px solid #ccc'
 *         }}
 *       >
 *         {/* Длинный контент *}
 *         {Array.from({ length: 50 }, (_, i) => (
 *           <div key={i}>Item {i + 1}</div>
 *         ))}
 *       </div>
 *       <p>Is scrolling: {isScrolling ? 'Yes' : 'No'}</p>
 *     </div>
 *   );
 * };
 *
 * // Использование для показа/скрытия элементов при скролле
 * const HeaderWithShadow = () => {
 *   const { isScrolling, onScroll } = useIsScrolling();
 *
 *   return (
 *     <div>
 *       <header
 *         style={{
 *           position: 'sticky',
 *           top: 0,
 *           boxShadow: isScrolling ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
 *           transition: 'box-shadow 0.3s ease'
 *         }}
 *       >
 *         Header Content
 *       </header>
 *       <main onScroll={onScroll} style={{ height: '400px', overflowY: 'auto' }}>
 *         {/* Контент *}
 *       </main>
 *     </div>
 *   );
 * };
 * ```
 */
export function useIsScrolling() {
    const [isScrolling, setIsScrolling] = useState(false);
    const onScroll = useCallback(event => {
        setIsScrolling(event.currentTarget.scrollTop > 1);
    }, []);
    return { isScrolling, onScroll };
}
